export type GlobalBestState =
  | { status: 'loading'; value: null }
  | { status: 'empty'; value: null }
  | { status: 'loaded'; value: number }
  | { status: 'error'; value: null };

export function formatGlobalBest(value: number | null): string {
  return value === null ? '------' : value.toString().padStart(6, '0');
}
